import { FilterOption } from '../../../components/ui';
import { BillsFilters } from './types';

export const getTableColumns = (t: any) => [
  { name: t('client.revshare.bills.table.columns.id'), key: 'id' },
  { name: t('client.revshare.bills.table.columns.account'), key: 'account' },
  { name: t('client.revshare.bills.table.columns.amount'), key: 'amount' },
  { name: t('client.revshare.bills.table.columns.status'), key: 'status' },
  { name: t('client.revshare.bills.table.columns.date'), key: 'date' },
];

export const getBillStatuses = (t: any): FilterOption[] => [
  { key: 'all', label: t('client.revshare.bills.filters.statuses.all') },
  { key: 'in_pending', label: t('client.revshare.bills.filters.statuses.in_pending') },
  { key: 'paid', label: t('client.revshare.bills.filters.statuses.paid') },
];

export const DEFAULT_FILTERS: BillsFilters = {
  search: '',
  amount: null,
  client_id: null,
  company_id: null,
  inner_company_id: null,
  partner_id: null,
  model_id: null,
  status: 'all',
  dateRange: 'all',
  customStartDate: null,
  customEndDate: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;
